const sortAcademicYearsByUpdateTime = (academicYears) =>
  academicYears.sort((a, b) => new Date(a.editInfo.updateAt) - new Date(b.editInfo.updateAt));

export const getAcademicYearsOnSelector = (allAcademicYears) => {
  const pastAcademicYears = sortAcademicYearsByUpdateTime(allAcademicYears.past);
  return { current: allAcademicYears.current, past: pastAcademicYears };
};
